import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { Cidade } from '@tivic-team/manager-ts/dist/grl/entities/cidade.entity';
import { CidadeDTO } from 'app/dtos/grl/cidade.dto';
import { CidadeSearch } from 'app/services/grl/cidade.search';
import { CidadeService } from 'app/services/grl/cidade.service';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ParentFormGroup } from 'utils/parent-formgroup';

@Component({
    selector: 'auto-complete-cidade',
    templateUrl: './auto-complete-cidade.component.html',
    styleUrls: ['./auto-complete-cidade.component.scss'],
    viewProviders: [ParentFormGroup]
})
export class AutoCompleteCidadeComponent implements OnInit {
    formGroup: FormGroup;
    cidades: Cidade[];
    cidadesFiltradas: Cidade[];

    @ViewChild('sgEstado', { static: false }) sgEstado: ElementRef;
    @ViewChild('cdCidade', { static: false }) cdCidade: ElementRef;

    constructor(private _cidadeService: CidadeService, private _controlContainer: ControlContainer) {}

    async ngOnInit() {
        this.formGroup = this._controlContainer.control as FormGroup
        this.formGroup.addControl('cidade', new FormControl());
        this.formGroup
            .get('cidade')
            .valueChanges.pipe(
                switchMap((value) => {
                    if (value && typeof value === 'string' && value.length > 2) {
                        return this._cidadeService.find(new CidadeSearch({ nmCidade: value }));
                    } else {
                        this.sgEstado.nativeElement.value = '';
                        return of(null);
                    }
                })
            )
            .subscribe((cidades) => (
                this.cidadesFiltradas = cidades
            ));
    }
    

    async ngAfterViewInit() {
        if(this.formGroup.value.cdCidade) {
            this.getById(this.formGroup.value.cdCidade)
        }

        this.formGroup
            .get('cdCidade')
            .valueChanges.pipe(
                switchMap(async (cdCidade) => {
                    this.getById(cdCidade);
                    return of(null);
                })
            )
            .subscribe();
    }

    displayFn(cidade: Cidade) {
        if (cidade) {
            return cidade.nmCidade;
        }
    }

    async getById(cdCidade: number) {
        if (cdCidade > 0) {
            let cidade: CidadeDTO = await this._cidadeService.get(cdCidade);
            cidade = cidade;

            if (cidade == null) console.log('Cidade indicada não existe no banco ou houve um erro ao busca-la.');
            else {
                this.formGroup.get('cidade').setValue(cidade);
                this.cdCidade.nativeElement.value = cidade.nmCidade;
                await this.alterarEstado(cidade);
            }
        }
    }

    async cidadeSelecionada($event) {
        let cidadeSelecionada = $event.option.value;
        this.formGroup.get('cdCidade').setValue(cidadeSelecionada?.cdCidade);
        await this.alterarEstado(cidadeSelecionada);
    }

    async alterarEstado(cidade: CidadeDTO | any) {
        if(cidade instanceof CidadeDTO) {
            if (cidade && cidade.cdEstado > 0) {
                this.sgEstado.nativeElement.value = cidade?.estado?.sgEstado;
                return;
            }
        } else { 
            if (cidade && cidade.cdCidade > 0) {
                this.sgEstado.nativeElement.value = cidade?.sgEstado || cidade?.nmEstado;
                return;
            }
        }
        this.sgEstado.nativeElement.value = '';
    }

    changeValue($event) {
        if($event.target.value.trim() === '') {
            this.cidadeSelecionada({option: {value: null}});
        }
    }
}
